module.exports = "/_next/static/images/chase-disher-1e4a84c17907dbb97c4bc6b1e6f6ce71.jpg";